module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-2a1ea742110d864b9dd38724ddc45694.webp";